import React, {useState} from "react";
import { Table, Icon, Button, Modal } from "semantic-ui-react";
import Axios from 'axios';

import APP_CONSTANTS from '../../../config/constants';

import EditModal from '../../modals/editModal';

import AddVendorUserModal from './add_user_modalnew';
import EditVendorUserModal from './edit_user_modalnew';
// import AlertVendorUserModal from './alert_user_modalnew';
import DeleteModal from '../../modals/deleteModal';


const UserTable = ({userData, vendorId}) => {

    const [openUserAddModal, setOpenUserAddModal] = useState(false)
    const [openUserEditModal, setOpenUserEditModal] = useState(false)
    const [openUserAlertModal, setOpenUserAlertModal] = useState(false)
    const [openUserDeleteModal, setOpenUserDeleteModal] = useState(false)
    const [userEditData, setUserEditData] = useState(false)
    const [userDeleteData, setUserDeleteData] = useState({})

    const userAddModal = () => {
        setOpenUserAddModal(true)
    }

    const handleCloseUserAddModal = () => {
        setOpenUserAddModal(false)
    }

    const userEditModal = (user) => {
        setUserEditData(user)
        setOpenUserEditModal(true)
    }

    const userAlertModal = (user) => {
        setOpenUserAlertModal(true)
    }

    const userDeleteModal = (user) => {
        setUserDeleteData(user)
        setOpenUserDeleteModal(true)
    }

    const handleCloseUserEditModal = () => {
        setOpenUserEditModal(false)
    }

    const handleCloseUserAlertModal = () => {
        setOpenUserAlertModal(false)
    }

    const handleCloseUserDeleteModal = () => {
        setOpenUserDeleteModal(false)
    }

    const handleDelete = () => {

        console.log("Delete Data ", userDeleteData.userName)
        
        const userDeleteHeader = {
            customerNo: localStorage.getItem('customerNo'),
            customerNumber: localStorage.getItem('customerNo'),
            customer_no: localStorage.getItem('customerNo'),
            userId: localStorage.getItem('userId'),
            userName: userDeleteData.userName,
            user_id: localStorage.getItem('userId')

        }

        Axios.delete(`${APP_CONSTANTS.BASE_URL}masters/users/vendor/${vendorId}`, {
            data: userDeleteHeader,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
            }
        }).then((response => {
            alert(response.data.message) 
            window.location.reload()      
        }))
            .catch(error => console.log(error))
    }


    return (
        <>
            <Table stackable size="small" selectable>
                <Table.Header className="w3-small">
                    <Table.Row>
                        <Table.HeaderCell colSpan="6" className="p-bold-600">
                            Users
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-600" textAlign="right">
                            <Button
                            type="button"
                            className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                            add_mode="add"
                            onClick={userAddModal}
                            >
                                <Icon name="plus" /> New
                            </Button>
                        </Table.HeaderCell>
                        
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell className="p-bold-500">
                            Username
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            Name
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            Email
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            Phone
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            Edit
                        </Table.HeaderCell>
                        {/* <Table.HeaderCell className="p-bold-500">
                            Alert
                        </Table.HeaderCell> */}
                        <Table.HeaderCell className="p-bold-500" colSpan="6">
                            Delete
                        </Table.HeaderCell>
                    </Table.Row>            
                </Table.Header>
                <Table.Body>
                    {userData && userData.length > 0 ? 
                        (
                            userData.map((user,userIndex) => (
                                <Table.Row key={userIndex}>
                                    <Table.Cell>
                                        {console.log("BranchData", userData)}
                                        {user.userName}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {user.realName}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {user.email}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {user.mobileNo}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Button onClick={() => userEditModal(user)} basic icon size="mini"><Icon name="edit" color="green" ></Icon></Button>
                                    </Table.Cell>
                                    {/* <Table.Cell>
                                        <Button onClick={() => userAlertModal(user)} basic icon size="mini"><Icon name="bell" color="grey" ></Icon></Button>
                                    </Table.Cell> */}
                                    <Table.Cell colSpan="6">
                                        <Button onClick={() => userDeleteModal(user)} basic icon size="mini"><Icon name="trash" color="red" ></Icon></Button>
                                    </Table.Cell>
                                    <EditModal size="tiny" open={openUserEditModal} onClose={handleCloseUserEditModal}>
                                        <Modal.Header>Edit Users</Modal.Header>
                                        <EditVendorUserModal handleCloseUserEditModal={handleCloseUserEditModal} userEditData={userEditData} />
                                    </EditModal>
                                    {/* <EditModal size="small" open={openUserAlertModal} onClose={handleCloseUserAlertModal}>
                                        <Modal.Header>Alert Users</Modal.Header>
                                        <AlertVendorUserModal handleCloseUserEditModal={handleCloseUserEditModal} userEditData={userEditData} />
                                    </EditModal> */}
                                    <DeleteModal open={openUserDeleteModal} onClose={handleCloseUserDeleteModal} handleDelete={handleDelete} /> 
                                </Table.Row>
                                
                            ))
                        )
                    :
                        (
                            <Table.Row>
                                <Table.Cell colSpan="6">No Records Found</Table.Cell>
                            </Table.Row>
                        )      
                    }
                </Table.Body>
            </Table>
            <EditModal size="tiny" open={openUserAddModal} onClose={handleCloseUserAddModal}>
                <Modal.Header>Add Users</Modal.Header>
                <AddVendorUserModal handleCloseUserAddModal={handleCloseUserAddModal} vendorId={vendorId} />
            </EditModal>
        </>
    )
}

export default UserTable